<div class="shift-compliance-container">
	<h1 class="shift-compliance-header">
		Become a Compliance <br class="d-none d-sm-block" />
		Hero Today!
	</h1>
	<p class="shift-compliance-para">
		With so many easy ways to get started, don't wait another minute to
		<br class="d-none d-sm-block" />
		start saving money, reducing your risk, and accelerating your business.
		<br class="d-none d-sm-block" />
		Take your first step towards Continuous Compliance Automation and
		<br class="d-none d-sm-block" />
		your RegOps journey by choosing from the options below:
	</p>
</div>
